/* eslint-disable react-hooks/exhaustive-deps */
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import { addLifeCycleStatus } from "../../../../components/CommonTimeLineCard/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import InternalTransactionDetailsPopup from "../../../../components/Transactions/InternalTransaction/InternalTransactionDetailsPopup/index.jsx";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import CommonTransactionApprovalCard from "../../../../components/_utils/CommonTransactionApprovalCard/index.jsx";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount.js";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";
import TimelinePopupContent from "../../../../components/_utils/TimelinePopupContent/index.jsx";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index.jsx";
import { getAllInternalAccounts } from "../../../../redux/features/accounts/internalAccount/index.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  ownerAccountsBalanceRefresh,
  ownerAccountsViewAll,
  setshowsuccestoast,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import { getAllCategories } from "../../../../redux/features/sharedResources/sharedResources.js";
import {
  internalTransactionsAddLabel,
  internalTransactionsDetailsById,
  internalTransactionsRemoveLabel,
  internalTransactionsViewAll,
} from "../../../../redux/features/transactions/internalTransactions/index.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../utils/configurationProvider.js";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat.js";

const InternalTransactionRecreateDashboard = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isDashboradCheck, startDateLocationState, endDateLocationState } =
    location.state || {};

  const mobileCheckingDivRef = useRef(null);
  const filterRef = useRef(null);
  const scrollRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);

  const getDefaultWeekSpan = () => {
    const today = dayjs();
    const weekAgo = today.subtract(6, "days");
    return [weekAgo.toDate(), today.toDate()];
  };

  const [dropdownOptions] = useState([50, 100]);
  const [selectedValue, setSelectedValue] = useState(50);
  const [storedPage] = useState(1);
  const [, setTotalPages] = useState(0);
  const [mainData, setMainData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [allScheduleTxnAccountsLoading, setAllScheduleTxnAccountsLoading] =
    useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [pageSize, setPageSize] = useState(
    window.innerWidth >= 3840 ? 192 : window.innerWidth >= 2560 ? 102 : 50,
  );
  const [currentStatus] = useState("all");
  const [startDateFilter, setStartDateFilter] = useState(
    startDateLocationState ?? "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    endDateLocationState ?? "",
  );

  const [isPaymentMethod, setIsPaymentMethod] = useState("");
  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: "",
    beneAccountId: "",
    bankAccountNo: "",
    bankAccountIFSC: "",
    ownerAccountId: "",
    amount: "",
    ownerbankAccountNo: "",
  });
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [txnAmountFilter, setTxnAmountFilter] = useState("");
  const [, setHideCaroursal] = useState(false);
  const [, setrefreshAnimation] = useState("");
  const [, setPrevBalance] = useState(null);
  const [, setRefactorId] = useState("");
  const [isSidebarOpen] = useState(false);
  const [, setIsFilterApplied] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [timelineLoading, setTimelineLoading] = useState(false);

  // Display dates
  const [startDate, setStartDate] = useState(() => {
    if (startDateLocationState) {
      return new Date(startDateLocationState * 1000);
    }

    return getDefaultWeekSpan()[0];
  });

  const [endDate, setEndDate] = useState(() => {
    if (endDateLocationState) {
      return new Date(endDateLocationState * 1000);
    }

    return getDefaultWeekSpan()[1];
  });
  const [paymentMethod, setPaymentMethod] = useState("");
  const [created_via, setCreatedVia] = useState("");
  const [accountNumber, setAccountNumber] = useState(
    txnPayLoad?.bankAccountNo ? txnPayLoad?.bankAccountNo : "",
  );
  const [accountName, setAccountName] = useState(
    txnPayLoad?.bankAccountName ? txnPayLoad?.bankAccountName : "",
  );
  const [txnAddDetails, setTxnAddDetails] = useState("");
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showRefactorDetailPop, setShowRefactorDetailPop] = useState(false);
  const [loading] = useState(false);
  const [currentCategory, setCurrentCategory] = useState("");
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [selectedBeneAccId, setSelectedBeneAccId] = useState(
    props?.bene_account_id ? props?.bene_account_id : "",
  );
  const [selectedOwnerAccId, setSelectedOwnerAccId] = useState(
    props?.Owner_account_id ? props?.Owner_account_id : "",
  );
  const [isConfidentialMethod, setIsConfidentialMethod] = useState(
    props?.bene_account_confidential === "Y"
      ? "Show only confidential"
      : props?.bene_account_confidential === "N"
        ? "Hide confidential"
        : (props?.bene_account_confidential ?? ""),
  );
  const [confidentialMethod, setConfidentialMethod] = useState(
    props?.bene_account_confidential === "Y"
      ? "Show only confidential"
      : props?.bene_account_confidential === "N"
        ? "Hide confidential"
        : (props?.bene_account_confidential ?? ""),
  );
  const [OpenTimeLinePopup, setOpenTimelinePopup] = useState(false);
  const [txnId, setTxnId] = useState(null);
  const [txnAmount, setTxnAmount] = useState("");
  const [txnSearchType, setTxnSearchType] = useState("");
  const [accountNameValue, setAccountNameValue] = useState("");

  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [labelsFilter, setFilterLabels] = useState([]);
  const [, setSearchUserText] = useState("");
  const [labelTxnId, setLabelTxnId] = useState([]);
  const [labels, setLabels] = useState([]);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const [, setSelectedLabels] = useState([]);
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState([]);
  const [openDistributionTimeline, setOpenDistributionTimeline] = useState([]);
  const [timelineTxnDetails, setTimelineTxnDetails] = useState([]);
  const [, setTimelineTxnId] = useState(null);

  const services = useSelector((state) => state.refreshToken.services);

  const { ownerAccBalanceLoading, ownerAccBalanceError } = useSelector(
    (state) => state.ownerAllVerification,
  );

  const { markerData } = useSelector((state) => state.multiEntitySwitcherSlice);

  const getWeekSpan = () => {
    const currentDate = dayjs(Date.now());
    const weekAgo = currentDate.subtract(6, "days");

    return [weekAgo.toDate(), currentDate.toDate()];
  };

  const isMobile = () => {
    try {
      return (
        getComputedStyle(
          mobileCheckingDivRef.current,
        ).backgroundColor.toString() !== "rgb(0, 0, 0)"
      );
    } catch {
      return false;
    }
  };

  const handleAction = async () => {
    try {
      setAllScheduleTxnAccountsLoading(true);

      const queryParams = {
        page_no: currentPage,
        page_item_count: pageSize,
        lifecycle_status: "rejected",
        refactor: false,
      };

      const addParamsBasedOnSelection = () => {
        if (currentCategory && currentCategory !== "Select category") {
          queryParams.category = currentCategory;
        }

        if (
          startDateFilter &&
          endDateFilter &&
          !isNaN(Number(startDateFilter)) &&
          !isNaN(Number(endDateFilter))
        ) {
          queryParams.start_date = Math.floor(Number(startDateFilter) / 1000);

          queryParams.end_date = Math.floor(Number(endDateFilter) / 1000);
        }

        if (labelsFilter?.length && labelsFilter !== "Select labels") {
          queryParams.labels = getLowercaseOnlyLabels(labelsFilter);
        }

        if (isPaymentMethod) {
          queryParams.payment_method = isPaymentMethod;
        }

        if (isConfidentialMethod) {
          queryParams.confidential_transaction = isConfidentialMethod;
        }

        if (txnSearchType === "additional") {
          if (txnAddDetails !== "") {
            queryParams.category_value = txnAddDetails;
            queryParams.category_name = "value";
          }
        }

        if (txnAmountFilter !== "") {
          queryParams.amount = txnAmountFilter;
        }

        if (selectedBeneAccId !== "") {
          queryParams.internal_account_id = selectedBeneAccId;
        }

        if (selectedOwnerAccId !== "") {
          queryParams.owner_account_id = selectedOwnerAccId;
        }

        if (created_via) {
          const createdViaMapping = {
            Manual: "Manual",
            Scheduled: "Scheduled_Transaction",
          };

          queryParams.created_via =
            createdViaMapping[created_via] || created_via?.toLowerCase();
        }
      };

      addParamsBasedOnSelection();

      const response = await dispatch(internalTransactionsViewAll(queryParams));

      const newData = response?.payload?.transactions || [];

      setMainData(response?.payload);
      setAccumulatedData(newData);

      setTotalCount(response?.payload?.total_count || 0);
    } catch (error) {
      setMainData([]);
      setAccumulatedData([]);
    } finally {
      setAllScheduleTxnAccountsLoading(false);
    }
  };

  const formatName = (name) => {
    if (!name) return "";

    return name
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const isLowercaseLabel = (label) =>
    typeof label === "string" && !/[A-Z]/.test(label);

  const getLowercaseOnlyLabels = (labelsList) =>
    (Array.isArray(labelsList) ? labelsList : []).filter(isLowercaseLabel);

  const openRefactorTxnDetailModal = (txnId) => {
    setRefactorId(txnId);
    setShowRefactorDetailPop(true);
  };

  const closeRefactorTxnDetailModal = () => {
    setShowRefactorDetailPop(false);
  };

  const closeTimelineModal = () => {
    setOpenTimelinePopup(false);
    setTimelineTxnId(null);
    setTimelineTxnDetails([]);
    setOpenApprovalTimeline([]);
    setOpenDistributionTimeline([]);
  };

  const hasAnyFilter =
    Boolean(currentCategory?.length) ||
    Boolean(labelsFilter?.length) ||
    Boolean(accountNumber?.length) ||
    Boolean(selectedBeneAccId?.length) ||
    Boolean(selectedOwnerAccId?.length) ||
    Boolean(txnAddDetails?.length) ||
    Boolean(txnAmountFilter) ||
    Boolean(isPaymentMethod) ||
    Boolean(isConfidentialMethod) ||
    Boolean(created_via?.length) ||
    Boolean(searchUserTextDebounce?.length) ||
    Boolean(
      startDateFilter &&
      endDateFilter &&
      !isNaN(Number(startDateFilter)) &&
      !isNaN(Number(endDateFilter)),
    );

  const noTransactionsFromAPI =
    !allScheduleTxnAccountsLoading &&
    Number(mainData?.total_count || 0) ===
      GlobalConfiguration.lengthCheckZero &&
    !hasAnyFilter;

  const noResultsAfterFilter =
    !allScheduleTxnAccountsLoading &&
    Number(mainData?.total_count || 0) ===
      GlobalConfiguration.lengthCheckZero &&
    hasAnyFilter;

  const openTimelineModal = async (txnId) => {
    setTimelineTxnDetails([]);
    setTimelineTxnId(txnId);
    setOpenTimelinePopup(true);
    setOpenApprovalTimeline([]);
    setOpenDistributionTimeline([]);
    setTimelineLoading(true);

    const res = await dispatch(
      internalTransactionsDetailsById({
        id: txnId,
      }),
    );

    if (res?.payload?.transaction) {
      const uiState = addLifeCycleStatus({
        lifecycle_status: res.payload.transaction[0]?.lifecycle_status,

        distribution_lifecycle_status:
          res.payload.transaction[0]?.distribution_lifecycle_status,

        services,
      });

      setTimelineTxnDetails([
        {
          ...res.payload.transaction[0],
          ...uiState,
        },
      ]);
    }

    setTimelineLoading(false);
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
    setTxnSearchType("additional");
  };

  const handleConfidentialMethod = (selectedConfidential) => {
    setIsConfidentialMethod(selectedConfidential);
  };

  const handlePaymentMethod = (selectedSettlement) => {
    setIsPaymentMethod(selectedSettlement);
  };

  const handleCreatedVia = (createdVia) => {
    setCreatedVia(createdVia);
  };

  const handleFilterDateRange = (startDateValue, endDateValue) => {
    setStartDateFilter(startDateValue);
    setEndDateFilter(endDateValue);
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(Number(storedPage) || currentPage);
    toggleDropdown();
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleRefresh = async (e, id, prevBalance) => {
    e.stopPropagation();

    setrefreshAnimation(id);
    setPrevBalance(prevBalance);

    try {
      const response = await dispatch(ownerAccountsBalanceRefresh(id));

      if (response?.payload?.status === true) {
        const data = accumulatedData?.map((item) => {
          if (
            response?.payload?.owner_accounts?.[0]?.owner_account_id ===
            item.owner_account_id
          ) {
            return {
              ...item,

              owner_account_balance_last_fetched_at_in_words:
                response.payload.owner_accounts[0]
                  .owner_account_balance_last_fetched_at_in_words,

              owner_account_balance:
                response.payload.owner_accounts[0].owner_account_balance,

              owner_account_balance_last_fetched_at:
                response.payload.owner_accounts[0]
                  .owner_account_balance_last_fetched_at,
            };
          }

          return item;
        });

        setAccumulatedData(data);

        setTimeout(() => {
          CommonToast({
            text: "Balance refreshed successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
            buttonNeeded: false,
          });

          dispatch(setshowsuccestoast());
        }, 250);
      } else {
        setTimeout(() => {
          toast.dismiss();

          const errorMessage =
            response?.payload?.response?.data?.errors?.base?.[
              GlobalConfiguration.lengthCheckZero
            ] ||
            response?.payload?.message ||
            "Something went wrong";

          CommonToast({
            text: errorMessage,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }, 500);
      }
    } catch (error) {
      CommonToast({
        text: error,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      throw error;
    }
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const getLastNDaysRange = (n = 7) => {
    const days = Number(n) || 7;
    return {
      startDate: dayjs()
        .subtract(days - 1, "day")
        .startOf("day")
        .unix(),
      endDate: dayjs().endOf("day").unix(),
    };
  };

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      !!currentCategory ||
        !!isPaymentMethod ||
        !!selectedBeneAccId ||
        !!txnAmountFilter ||
        !!created_via ||
        !!selectedOwnerAccId ||
        !!isConfidentialMethod ||
        !!labelsFilter?.length ||
        !!txnAddDetails ||
        !!(startDateFilter && endDateFilter),
    );
  };

  const handleClearParams = (e) => {
    e?.stopPropagation();
    setTxnAmount("");
    setTxnAddDetails("");
    setTxnAmountFilter("");
    setCurrentCategory("");
    setIsPaymentMethod("");
    setPaymentMethod("");
    setIsConfidentialMethod("");
    setConfidentialMethod("");
    setSelectedBeneAccId("");
    setAccountName("");
    setSelectedOwnerAccId("");
    setAccountNumber("");
    setFilterLabels([]);
    setSearchUserText("");
    setSearchUserTextDebounce("");
    setCreatedVia("");
    setTxnSearchType("");
    setTxnPayLoad((prev) => ({
      ...prev,
      amount: "",
      ownerbankAccountNo: "",
      ownerAccountId: "",
      beneAccountId: "",
      bankAccountName: "",
      bankAccountNo: "",
      bankAccountIFSC: "",
    }));

    const [defaultStart, defaultEnd] = getDefaultWeekSpan();

    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setStartDateFilter("");
    setEndDateFilter("");

    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setShowSearchBar(false);
    setShowInnerSearchBar(false);
  };

  const fetchData = async () => {
    setLoadingData(true);

    let response;
    let data = [];

    try {
      switch (active) {
        case "Internal account":
          response = await dispatch(
            getAllInternalAccounts({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );

          if (response?.payload?.status) {
            data =
              response.payload.internal_accounts?.map((itm) => ({
                id: itm.id,
                Name: itm.name,
                Account_number: itm.bank_acc_no,
                display: itm.name,
                IFSC_code: itm.ifsc_code,
                Contact_number: itm.contact_no,
                Email_ID: itm.email_id,
              })) || [];
          }

          break;

        case "Owner account":
          response = await dispatch(
            ownerAccountsViewAll({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );

          if (response?.payload?.status) {
            data =
              response.payload.owner_accounts?.map((itm) => ({
                id: itm.id,
                Account_number: itm.bank_acc_no,
                display: itm.bank_acc_no,
                Name: itm.name,
                IFSC_code: itm.ifsc_code,
                Email_ID: itm.email_id,
              })) || [];
          }

          break;

        case "Labels": {
          const normalizedSearch = (searchUserTextDebounce || "")
            .toLowerCase()
            .trim();

          const availableLabels =
            JSON.parse(sessionStorage.getItem("internalTxnLabels") || "[]") ||
            labels;

          data =
            getLowercaseOnlyLabels(availableLabels)
              ?.filter((itm) =>
                (itm || "").toLowerCase().includes(normalizedSearch),
              )
              ?.map((val) => ({
                id: val,
                Label: val,
              })) || [];

          break;
        }

        case "Category":
          response = await dispatch(
            getAllCategories({
              search_string: searchUserTextDebounce,
            }),
          );

          data =
            response?.payload?.categories?.map((itm) => ({
              id: itm.name,
              Category: itm.name,
              Description: itm?.description || "Not given",
            })) || [];

          break;

        case "Search":
          setSearchUserText(searchUserTextDebounce);

          setLoadingData(false);

          break;

        default:
          data = [];
          setLoadingData(false);
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);

      data = [];
    } finally {
      setInputData([...data]);
      setLoadingData(false);
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload?.response?.data?.ids?.unsuccessful_ids?.[0]?.errors ||
      res?.payload;

    const e = res?.error;

    if (typeof p === "string") {
      return p;
    }

    if (p?.message) {
      return p.message;
    }

    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];

      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }

    if (e?.message) {
      return e.message;
    }

    return "Something went wrong";
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);

    if (!labelActionDispatchedRef.current) {
      return;
    }

    labelActionDispatchedRef.current = false;
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);

    const recordIds = toArray(labelTxnId);

    const res = await dispatch(
      internalTransactionsAddLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );

    if (internalTransactionsAddLabel.fulfilled.match(res)) {
      setTimeout(() => {
        toast.dismiss();

        CommonToast({
          text: "Labels assigned successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
      }, IntervalConfiguration.intervalExtraLarge);

      await handleAction();

      labelActionDispatchedRef.current = true;
    }

    if (internalTransactionsAddLabel.rejected.match(res)) {
      toast.dismiss();

      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    setLabelPopupLoading(false);

    return internalTransactionsAddLabel.fulfilled.match(res);
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);

    const recordIds = toArray(labelTxnId);

    const res = await dispatch(
      internalTransactionsRemoveLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );

    if (internalTransactionsRemoveLabel.fulfilled.match(res)) {
      setTimeout(() => {
        toast.dismiss();

        CommonToast({
          text: "Labels unassigned successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
      }, IntervalConfiguration.intervalExtraLarge);

      await handleAction();

      labelActionDispatchedRef.current = true;
    }

    if (internalTransactionsRemoveLabel.rejected.match(res)) {
      toast.dismiss();

      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    setLabelPopupLoading(false);
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    if (isDashboradCheck && startDateLocationState && endDateLocationState) {
      setStartDate(new Date(startDateLocationState * 1000));
      setEndDate(new Date(endDateLocationState * 1000));

      return;
    }

    const { startDate: defaultStart, endDate: defaultEnd } =
      getLastNDaysRange(7);

    setStartDate(new Date(defaultStart * 1000));

    setEndDate(new Date(defaultEnd * 1000));
  }, [isDashboradCheck, startDateLocationState, endDateLocationState]);

  useEffect(() => {
    if (startDate === "" || endDate === "") {
      const [c, w] = getWeekSpan();

      setStartDate(c);
      setEndDate(w);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    const handleResize = () => {
      if (isMobile()) {
        closeRefactorTxnDetailModal();
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (scrollRef) {
      if (scrollRef?.current?.scrollWidth > scrollRef?.current?.clientWidth) {
        setHideCaroursal(true);
      } else {
        setHideCaroursal(false);
      }
    }
  }, [
    currentCategory,
    startDateFilter,
    endDateFilter,
    selectedBeneAccId,
    isPaymentMethod,
    accountNumber,
    created_via,
    txnAmountFilter,
    isConfidentialMethod,
  ]);

  useEffect(() => {
    handleAction();
  }, [
    markerData,
    dispatch,
    currentPage,
    pageSize,
    isPaymentMethod,
    currentStatus,
    endDateFilter,
    startDateFilter,
    txnAmount,
    txnAddDetails,
    txnAmountFilter,
    currentCategory,
    isConfidentialMethod,
    created_via,
    selectedBeneAccId,
    selectedOwnerAccId,
    labelsFilter,
  ]);

  useEffect(() => {
    const newTotalPages = Math.ceil(totalCount / pageSize);

    setTotalPages(newTotalPages);

    setCurrentPage((prevPage) => {
      if (newTotalPages === 0) {
        return 1;
      }

      if (prevPage > newTotalPages) {
        return newTotalPages;
      }

      return prevPage;
    });
  }, [totalCount, pageSize]);

  useEffect(() => {
    if (ownerAccBalanceLoading) {
      UniversalRefreshToast();
    }

    if (!ownerAccBalanceLoading && !ownerAccBalanceError) {
      setTimeout(() => {
        toast.dismiss();
      }, 150);
    }
  }, [ownerAccBalanceLoading]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [
    currentCategory,
    startDateFilter,
    endDateFilter,
    txnAmountFilter,
    isPaymentMethod,
    created_via,
    selectedBeneAccId,
    selectedOwnerAccId,
    isConfidentialMethod,
    labelsFilter,
    txnAddDetails,
  ]);

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active, searchUserTextDebounce, labels]);

  useEffect(() => {
    if (isLabelPopupOpen) {
      const availableLabels = sessionStorage?.getItem("internalTxnLabels");

      const parsedLabels = JSON?.parse(availableLabels || "[]");

      setLabels(getLowercaseOnlyLabels(parsedLabels));
    }
  }, [isLabelPopupOpen]);

  return (
    <>
      {showRefactorDetailPop && !isMobile() && (
        <div
          className="fixed top-top-base left-left-base w-screen h-screen z-max-zindex bg-Primary-black bg-opacity-dark-opacity"
          onClick={() => {
            closeRefactorTxnDetailModal();
          }}
        >
          <InternalTransactionDetailsPopup
            setShowInternalTxnDetailPop={(x) => x}
            setErrorMessage={(x) => x}
            closeInternalTxnDetailModal={closeRefactorTxnDetailModal}
            internal_txn_id={txnId}
            type="internal_txn_detail_modal"
          />
        </div>
      )}

      {OpenTimeLinePopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-max-zindex bg-Primary-black bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle="Transaction timeline"
            closeiconhandleFunction={closeTimelineModal}
            isscrollRequired={true}
          >
            {timelineLoading ? (
              <div className="flex justify-center items-center w-full py-padding-xl h-full">
                <Loader />
              </div>
            ) : timelineTxnDetails.length > 0 ? (
              <TimelinePopupContent
                logsData={timelineTxnDetails}
                showDistributionRightIcon={false}
                showApprovalLeftIcon={false}
                showApprovalTimeline={true}
                showDistributionTimeline={false}
                openApprovalTimeline={openApprovalTimeline}
                openDistributionTimeline={openDistributionTimeline}
                setOpenApprovalTimeline={setOpenApprovalTimeline}
                setOpenDistributionTimeline={setOpenDistributionTimeline}
                handleApprovalClick={() => {}}
                cardType="double"
                popUpMode={true}
              />
            ) : (
              <div className="flex justify-center items-center w-full py-padding-xl">
                <p className="text-text-secondary text-font-sm">
                  No timeline data available.
                </p>
              </div>
            )}
          </LargePopupRedirect>
        </div>
      )}

      {isLabelPopupOpen && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setIsLabelPopupOpen(true);
          }}
          className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={labelTxnId}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={accumulatedData
              ?.filter((t) => labelTxnId.includes(t.txn_id))
              ?.map((t) => ({
                ...t,
                id: t.txn_id,
              }))}
            onClose={handleClose}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}

      <div className="flex flex-col items-center relative w-width-full h-full-height overflow-hidden">
        <div className="bene_div_container Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act relative w-full">
          <div className="Qmd:min-h-navbar-breadcrumb-height bg-primary-nav"></div>

          <TopNavComponent
            BottomHeader="Recreate transaction dashboard"
            BottomSubText="The following transactions were rejected but their data can be used to recreate new ones."
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,

              showSearchBar: showSearchBar,

              isSearchDisabled: allScheduleTxnAccountsLoading,

              onSearchInput: handleSearch,

              searchText: searchUserTextDebounce,

              searchPlaceholder: "Search internal transaction",

              filterPlaceholder: "transaction details",

              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: txnAddDetails,

                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration?.lengthCheckOne);

                    handleSearch(val);
                    setTxnAddDetails(val);
                  },

                  isDropdown: false,
                  isDisabled: loading,
                },

                {
                  name: "Internal account",
                  short_name: "Int A/c",
                  isMulti: false,
                  value: selectedBeneAccId,

                  displayValue: formatName(accountName || accountNameValue),

                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);

                    setSelectedBeneAccId(val);
                  },

                  setDisplayValue: (val) => {
                    setAccountName(val);
                    setAccountNameValue(val);
                  },

                  isDropdown: true,
                  valueType: "string",
                  isDisabled: loading,
                },

                {
                  name: "Owner account",
                  short_name: "Own A/c",
                  isMulti: false,
                  value: selectedOwnerAccId,

                  displayValue: standardAccountNumberFormat(
                    accountNumber,
                    true,
                  ),

                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);

                    setSelectedOwnerAccId(val);
                  },

                  setDisplayValue: setAccountNumber,

                  valueType: "string",
                  isDropdown: true,
                  isDisabled: loading,
                },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: labelsFilter,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setFilterLabels(getLowercaseOnlyLabels(val));
                  },
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: loading,
                },
                {
                  name: "Amount",
                  short_name: "Amt - INR",
                  isMulti: false,
                  value: txnAmountFilter,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setTxnAmountFilter(val);
                  },
                  displayValue: FormatAmount({
                    price: txnAmountFilter,
                  }),
                  isDropdown: false,
                  isDisabled: loading,
                  valueType: "number",
                },
              ],
              filters: [
                {
                  name: "Payment method",
                  filterType: "dropdown",
                  variant: "single",
                  value: paymentMethod,
                  dropdownType: "PaymentMethod",
                  options: ["NEFT", "RTGS"],
                  dropdownPlaceHolder: "Select type",
                  isDisabled: false,
                  statusPop: true,
                  handleChange: (value) => {
                    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                    setPaymentMethod(value);
                    handlePaymentMethod(value);
                  },
                },
                {
                  name: "Created via",
                  filterType: "dropdown",
                  variant: "single",
                  value: created_via,
                  options: ["Manual", "Scheduled"],
                  dropdownPlaceHolder: "Select type",
                  isDisabled: false,
                  handleChange: (value) => {
                    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                    setCreatedVia(value);
                    handleCreatedVia(value);
                  },
                },
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDate && endDate,
                  isDisable: false,
                  startDate:
                    startDate ||
                    (startDateFilter
                      ? new Date(Number(startDateFilter))
                      : null),
                  endDate:
                    endDate ||
                    (endDateFilter ? new Date(Number(endDateFilter)) : null),
                  handleChange: (dates) => {
                    const [start, end] = dates || [];
                    if (!start && !end) {
                      const [defaultStart, defaultEnd] = getDefaultWeekSpan();
                      setStartDate(defaultStart);
                      setEndDate(defaultEnd);
                      setStartDateFilter("");
                      setEndDateFilter("");
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      return;
                    }
                    setStartDate(start);
                    setEndDate(end);
                    if (start && end) {
                      handleFilterDateRange(
                        Math.floor(start.getTime()),
                        Math.floor(end.getTime()),
                      );
                    }
                  },
                },
                {
                  name: "Show/hide confidential transactions",
                  filterType: "dropdown",
                  variant: "single",
                  value: confidentialMethod,
                  options: ["Show only confidential", "Hide confidential"],
                  dropdownPlaceHolder: "Select type",
                  isDisabled: false,
                  statusPop: true,
                  handleChange: (value) => {
                    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                    setConfidentialMethod(value);
                    handleConfidentialMethod(value);
                  },
                },
              ],
              isSearchClearAllDisabled: allScheduleTxnAccountsLoading,
              isFilterClearAllDisabled: !(
                paymentMethod?.length > GlobalConfiguration?.lengthCheckZero ||
                confidentialMethod?.length >
                  GlobalConfiguration?.lengthCheckZero ||
                (startDateFilter && endDateFilter) ||
                allScheduleTxnAccountsLoading ||
                created_via?.length > GlobalConfiguration.lengthCheckZero
              ),
              inputData: inputData,
              active: active,
              setActive: setActive,
              loadingData: loadingData,
              setLoading: setLoadingData,
              isShowFilter: true,
            }}
          />
        </div>
        <div
          className={`relative flex flex-col items-center w-width-full h-height-full bg-primary-bg ${
            showInnerSearchBar
              ? "overflow-y-hidden cursor-pointer-none pointer-events-none"
              : "overflow-auto"
          }`}
        >
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop top-top-base left-left-base opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
          )}

          {allScheduleTxnAccountsLoading ? (
            <div
              className={`m-auto justify-center items-center flex ${
                showInnerSearchBar
                  ? "overflow-y-hidden cursor-pointer-none pointer-events-none"
                  : ""
              }`}
            >
              <Loader />
            </div>
          ) : accumulatedData?.length > GlobalConfiguration?.lengthCheckZero ? (
            <div
              className="scroll flex flex-col w-width-full items-center justify-center"
              ref={filterRef}
            >
              <div className="scroll flex flex-col items-center gap-gap-md justify-center w-width-full lg:w-auto px-padding-md lg:px-padding-base pb-padding-md">
                {accumulatedData
                  ?.filter(
                    (account) => account?.lifecycle_status !== "abandoned",
                  )
                  ?.map((account, index) => (
                    <div
                      key={account?.txn_id}
                      className={`beneTxn_recreate_data_card w-width-full ${
                        isSidebarOpen ? "opacity-light-opacity" : ""
                      } ${
                        index === GlobalConfiguration?.lengthCheckZero
                          ? "mt-margin-md"
                          : ""
                      }`}
                    >
                      <CommonTransactionApprovalCard
                        entries={[
                          [
                            {
                              type: "textSubtext",
                              text: `INR ${FormatAmount({
                                price: account?.amount || "0",
                              })}`,
                              subText: "Amount",
                              textColor: "var(--settled)",
                              isBold: true,
                            },
                            {
                              type: "textSubtext",
                              text: account?.internal_account_name,
                              subText: "Account name",
                              icon:
                                account?.confidential_transaction === "Y" &&
                                ICONS?.CONFIDENTIAL_TRANSACTION,
                            },
                            {
                              type: "cta",
                              text: getLowercaseOnlyLabels(account?.labels)
                                ?.length
                                ? getLowercaseOnlyLabels(account?.labels).join(
                                    ", ",
                                  )
                                : "No labels assigned",
                              subText: "Labels",
                              onClick: (e) => {
                                if (
                                  services?.includes("ALabel") &&
                                  services?.includes("RLabel")
                                ) {
                                  e.stopPropagation();
                                  setLabelTxnId([account?.txn_id]);
                                  setSelectedLabels(
                                    getLowercaseOnlyLabels(account?.labels),
                                  );
                                  setIsLabelPopupOpen(true);
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "ALabel,RLabel",
                                    },
                                  });
                                }
                              },
                            },
                          ],
                        ]}
                        ctaBtn2Text="Approval history"
                        ctaBtn2OnClick={(e) => {
                          if (!isSidebarOpen) {
                            e.stopPropagation();
                            openTimelineModal(account?.txn_id);
                            setTxnId(account?.txn_id);
                          }
                        }}
                        ctaBtn1Text="Additional details"
                        ctaBtn1OnClick={(e) => {
                          if (!isSidebarOpen) {
                            e.stopPropagation();
                            openRefactorTxnDetailModal();
                            setTxnId(account?.txn_id);
                          }
                        }}
                        alerts={[]}
                        cardState="default"
                        thisIsARecreateCard
                        ownerAccountNumber={account?.owner_account_bank_acc_no}
                        ownerAccountIfsc={
                          account?.owner_account_ifsc_code || ""
                        }
                        ownerAccountNumberSubtext="Source account"
                        ownerAccountBalance={
                          account?.owner_account_balance ?? "Not available"
                        }
                        ownerAccountBalanceSubtext={`Balance - ${
                          account?.owner_account_balance_last_fetched_at_in_words ||
                          "Not available"
                        }`}
                        ownerAccountBalanceOnClick={(e) => {
                          handleRefresh(
                            e,
                            account?.owner_account_id,
                            account?.owner_account_balance,
                          );
                        }}
                        destinationAccountNumber={
                          account?.internal_account_bank_acc_no
                        }
                        destinationAccountIfsc={
                          account?.internal_account_ifsc_code || ""
                        }
                        destinationAccountNumberSubtext="Destination account"
                        destinationAccountText={
                          account?.internal_account_ifsc_code
                        }
                        destinationAccountSubtext="IFSC code"
                        createdOnRequired={false}
                        recreateOnClick={() => {
                          if (!services.includes("CInternalTxn")) {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "CInternalTxn",
                              },
                            });
                          } else if (!isSidebarOpen) {
                            sessionStorage.setItem(
                              "recreate_int_txn_id",
                              JSON.stringify(account?.txn_id),
                            );
                            navigate(
                              "/internal_transaction_dashboard/create_internal_transaction",
                              {
                                state: {
                                  txn_id: account?.txn_id,
                                  type: "refactorFlow",
                                },
                              },
                            );
                          }
                        }}
                        recreateBtnText="Recreate transaction"
                        recreateBtnIsDisabled={
                          !services.includes("CInternalTxn")
                        }
                      />
                    </div>
                  ))}
              </div>
            </div>
          ) : noResultsAfterFilter ? (
            <div className="w-width-full h-full flex items-center justify-center">
              <div className="flex flex-col items-center gap-gap-sm">
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className="w-graphic-width-md h-graphic-rectangle-height-md"
                />

                <p className="text-text-primary text-font-sm items-center">
                  No data found.
                </p>

                <PrimaryButton
                  btnText="Clear parameters"
                  handleFunction={handleClearParams}
                  enabledBgColor="var(--primary-nav-act)"
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            </div>
          ) : noTransactionsFromAPI ? (
            <div className="w-width-full h-full flex items-center justify-center">
              <div className="w-width-full h-full flex items-center justify-center">
                <div className="flex flex-col items-center gap-gap-sm">
                  <img
                    src={ICONS?.NO_PENDING_TRANSACTION}
                    alt="No accounts found"
                    className="w-graphic-width-md h-graphic-rectangle-height-md"
                  />

                  <p className="text-text-primary text-center text-font-sm pt-padding-sm items-center">
                    There are no more transactions that require recreation.
                  </p>
                  <PrimaryButton
                    btnText="Internal transaction dashboard"
                    handleFunction={() =>
                      navigate("/internal_transaction_dashboard")
                    }
                    enabledBgColor="var(--primary-act)"
                    enabledTextColor="var(--text-primary)"
                  />
                </div>
              </div>
            </div>
          ) : null}
        </div>
        {!allScheduleTxnAccountsLoading &&
          accumulatedData?.length > GlobalConfiguration?.lengthCheckZero && (
            <div className="relative w-full bg-primary-nav z-z-index-tooltip">
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop top-0 left-left-base opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
              )}
              <PaginationComponent
                handleSelect={handleSelect}
                selectedValue={selectedValue}
                data={mainData}
                pageSize={pageSize}
                dropdownOptions={dropdownOptions}
                handlePagination={handlePagination}
                currentPage={currentPage}
                setIsOpen={setIsOpen}
              />
            </div>
          )}
      </div>
    </>
  );
};

export default InternalTransactionRecreateDashboard;
